module.exports = __webpack_public_path__ + "assets/img/b54b-bj.svg";